import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { routePath } from 'app/services/helpers'
import axios from 'app/services/http/axios';

// -------

import {Actions} from './slice';
import { Api } from 'modules/Admin/Inventory'

// -------

function* getProductDetails({payload: {id}}) {
  try {
    const route = routePath(Api.productDetails, { id })

    console.log('=== BASIC API CALL DEBUG ===');
    console.log('Details API Route:', route);
    console.log('Making API call...');

    const response = yield call(axios.get, route);

    console.log('=== BASIC API RESPONSE DEBUG ===');
    console.log('Details API Response:', response);
    console.log('Response Keys:', Object.keys(response));

    yield put(Actions.getProductDetailsSuccess(response));

  } catch (e) {
    console.log('=== BASIC API ERROR ===');
    console.log('Details API Error:', e);
    return yield put(Actions.getProductDetailsFailed(e));
  }
}

function* getProductComplete({payload: {id, filters}}) {
  try {
    const route = routePath(Api.productComplete, { id })

    // Add any filters as query parameters
    const queryParams = filters ? new URLSearchParams(filters).toString() : '';
    const finalRoute = queryParams ? `${route}?${queryParams}` : route;

    console.log('=== API CALL DEBUG ===');
    console.log('Complete API Route:', finalRoute);
    console.log('Making API call...');

    const response = yield call(axios.get, finalRoute);

    console.log('=== API RESPONSE DEBUG ===');
    console.log('Complete API Response:', response);
    console.log('Response Keys:', Object.keys(response));

    yield put(Actions.getProductCompleteSuccess(response));

  } catch (e) {
    console.log('=== API ERROR ===');
    console.log('Complete API Error:', e);
    return yield put(Actions.getProductCompleteFailed(e));
  }
}

export function* watchProductsDetailsSaga() {
  yield takeLatest(Actions.getProductDetails.type, getProductDetails)
  yield takeLatest(Actions.getProductComplete.type, getProductComplete)
}

export default watchProductsDetailsSaga
